import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useCallback } from "react";
import { all, none, pluck, equals, filter, map, pipe } from "ramda";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { CheckboxFieldset } from "@interdependence-ui";
import { useOrganizationsContext } from "@webapi/contexts/organizations";
import { extendedSystemStylesProps } from "@mixins";
import { sortUnits } from "utils/sort";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
export default /*#__PURE__*/memo(function SelectOrganizationsGroup(props) {
  var selected = props.selected,
    includedOptions = props.includedOptions,
    reportingUnits = props.reportingUnits,
    onChange = props.onChange;
  var _useOrganizationsCont = useOrganizationsContext(),
    regions = _useOrganizationsCont.regions;
  var _useMatomo = useMatomo(),
    trackEvent = _useMatomo.trackEvent;
  var regionIds = sortUnits(["SE"].concat(_toConsumableArray(pluck("id", regions))));
  var availableOptions = [{
    id: "all-regions",
    label: "Regioner och Riket",
    units: regionIds
  }, {
    id: "all-reporting",
    label: "Rapporterande enheter (".concat((reportingUnits === null || reportingUnits === void 0 ? void 0 : reportingUnits.length) || 0, ")"),
    units: reportingUnits
  }];
  var checkIfChecked = useCallback(function (selectable) {
    if (!selectable || (selectable === null || selectable === void 0 ? void 0 : selectable.length) === 0 || selected.length === 0) return false;
    if (all(function (x) {
      return selected.includes(x);
    }, selectable)) return true;
    if (none(function (x) {
      return selected.includes(x);
    }, selectable)) return false;
    return "mixed";
  }, [selected]);
  var options = pipe(filter(function (option) {
    return includedOptions.includes(option.id);
  }), map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      checked: checkIfChecked(option.units)
    });
  }))(availableOptions);
  var handleSelect = function handleSelect(add, optionId) {
    var option = options.find(function (x) {
      return x.id === optionId;
    });
    // we always want to go from partial to full selection
    if (option.checked === "mixed") add = true;
    trackEvent({
      category: "Enhetslistor",
      action: "Välj flera",
      name: option.label
    });
    onChange(add, option.units);
  };
  return /*#__PURE__*/_jsx(CheckboxFieldset, _objectSpread(_objectSpread({
    id: "select-multiple-units",
    legend: "F\xF6rinst\xE4llda enhetslistor",
    name: "organizationsgroup",
    icon: "list",
    marginTop: "2rem",
    options: options
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    updateSelected: handleSelect
  }));
}, function (curr, prev) {
  return equals(curr.selected, prev.selected) && equals(prev.reportingUnits, curr.reportingUnits);
});